//-----------------------------------------------------------------------------
//----- Copyright deersoft 2015 - 2018 www.deersoft.de
//-----------------------------------------------------------------------------
import React, { Component } from 'react';
import { Form, Table } from 'semantic-ui-react'
import LocalizedStrings from "../../localization/TradeShowData";
import LRModal from '../Basics/BasicModal';
import BasicUnitInput from '../Basics/BasicUnitInput';

import { globalCallbacks } from "../../util/callback";
import { BASE_UNIT_DATE, BASE_UNIT_FORCE, BASE_UNIT_NUMBER, BASE_UNIT_WEIGHT, EMPTY_UUID } from '../../util/defines';
import DynamicTable from '@component/Basics/DynamicTableView';
import SymbolMapSelector from '@component/RessourceManager/SymbolMapSelector';


//-----------------------------------------------------------------------------
// The component for the TreeControl
class TradeShowData_Export extends Component 
{
  constructor(props)
  {
    super(props);
    this.state = 
    { 
      open : false,
      Data :{},
      DataArray :[]
    }
  }

  componentDidMount = () => 
  {
    this.setUpCallbacks();
  }

  show = async() => 
  {
    this.setState( { 
        open : true, 
      });
  }

  close = () => 
  {
    this.setState({open : false});
  }
  ok = () => 
  {
    window.LR_ImportTradeShowLoadExchange({Data: this.state.Data, DataArray: {Symbols: this.state.DataArray}});
    this.setState({open : false});
  }
    
  render() 
  {
    let open = this.state.open;
    if(!open) {return <div/>}

    //------------------------------------------------------------------
    // Loads
    const headerIdent = [
                { editable: false, sortable: true, ident: "Name", label: LocalizedStrings.Name },
                { editable: false, unit: BASE_UNIT_NUMBER, sortable: true, ident: "Count", label: LocalizedStrings.Count },
                { editable: false, unit: BASE_UNIT_WEIGHT, sortable: true, ident: "Weight", label: LocalizedStrings.Weight },
                { editable: false, unit: BASE_UNIT_FORCE, sortable: true, ident: "Force", label: LocalizedStrings.Force },
            ];
    const cellRender = (entry, rowIndex) => {
      return {
        Name: entry.Name,
        Count: <BasicUnitInput readOnly value={entry.Count}  baseUnit={BASE_UNIT_NUMBER} />,
        Weight: <BasicUnitInput readOnly value={entry.Weight}  baseUnit={BASE_UNIT_WEIGHT} />,
        Force: <BasicUnitInput readOnly value={entry.Force}  baseUnit={BASE_UNIT_FORCE} />,
      }
    }
    //------------------------------------------------------------------
    // Loads
    const headerIdent_Force = [
      { editable: false, sortable: true, ident: "Name", label: LocalizedStrings.Name },
      { editable: false, unit: BASE_UNIT_FORCE, sortable: true, ident: "Force", label: LocalizedStrings.Force },
      { editable: false, sortable: true, ident: "Symbol", label: LocalizedStrings.Symbol },
    ];
    const cellRender_Force = (entry, rowIndex) => {
      return {
      Name: entry.Name,
      Symbol: <SymbolMapSelector value={this.state.DataArray[rowIndex].UUID} updateData={ updateObj => { 
        this.setState({DataArray: this.state.DataArray.map((item, i) => {
          if (i === rowIndex) {
            return { UUID: updateObj.newUUID };
          }
          return item;
        }
        )})
      }}/>,
      Force: <BasicUnitInput readOnly value={entry.Force}  baseUnit={BASE_UNIT_FORCE} />,
      }
    }

    return (
      <LRModal  open={open} 
                onCancelClick={this.close} 
                closeOnDimmerClick={false} 
                scrolling={false}
                title={LocalizedStrings.Header}
                onOkClick={this.ok}>
                  <Form>
                    <Form.Input label={LocalizedStrings.TradeShowName}  value={this.state.Data.TradeShowName} readOnly/>
                    <Form.Input label={LocalizedStrings.Hall}  value={this.state.Data.Hall} readOnly/>
                    <Form.Input label={LocalizedStrings.Booth}  value={this.state.Data.Booth} readOnly/>
                    <Form.Input label={LocalizedStrings.Company}  value={this.state.Data.Company} readOnly/>
                    <BasicUnitInput label={LocalizedStrings.Date} baseUnit={BASE_UNIT_DATE}  value={this.state.Data.Created}/> 
                  </Form>
                  <DynamicTable
                      cellRender={cellRender}
                      headerIdent={headerIdent}
                      cellData={this.state.Data.Loads}
                  />
                  <DynamicTable
                      cellRender={cellRender_Force}
                      headerIdent={headerIdent_Force}
                      cellData={this.state.Data.Points}
                  />
      </LRModal>
    )
  }

  setUpCallbacks()
  {

    globalCallbacks.ShowImportTradeShowData = (args) => 
    { 
      this.show();
      this.setState({Data : args, DataArray: args.Points.map(()=> {return {UUID: EMPTY_UUID}})});
    }
    
  }
}

export default TradeShowData_Export